interface ItemWithId {
  id: unknown;
}

const getItemById = <T extends ItemWithId>(collection: T[], id: T['id']) => collection.find((item) => item.id === id);

export default getItemById;
